import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

function AuthCallback() {
    const navigate = useNavigate();
    const { saveToken } = useAuth();

    useEffect(() => {
        const hash = window.location.hash;
        const tokenMatch = hash.match(/token=([^&]+)/);

        if (tokenMatch && tokenMatch[1]) {
            saveToken(tokenMatch[1]);
            navigate('/dashboard', { replace: true });
        } else {
            navigate('/login?error=no_token', { replace: true });
        }
    }, [navigate, saveToken]);

    return (
        <div className="login-page">
            <div className="login-card">
                <div className="loading">
                    <div className="spinner"></div>
                    <span>Autenticando...</span>
                </div>
            </div>
        </div>
    );
}

export default AuthCallback;
